import { render, staticRenderFns } from "./DescriptionInfoVideoBlock.vue?vue&type=template&id=0abd63c0&"
import script from "./DescriptionInfoVideoBlock.vue?vue&type=script&lang=js&"
export * from "./DescriptionInfoVideoBlock.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionInfoVideoBlock.vue?vue&type=style&index=0&id=0abd63c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports